const CURRENCIES = [
  {
    region: "ja",
    currency: "JPY",
    locale: "ja-JP",
  },
  {
    region: "jp",
    currency: "JPY",
    locale: "ja-JP",
  },
  {
    region: "au",
    currency: "AUD",
    locale: "en-US",
  },
  {
    region: "se",
    currency: "SEK",
    locale: "en-US",
  },
  {
    region: "ko",
    currency: "KRW",
    locale: "ko",
  },
  {
    region: "kr",
    currency: "KRW",
    locale: "ko",
  },
];

export default CURRENCIES;
